import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/leaflet-geosearch/leaflet-geosearch/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Playground from '../components/Playground';
import Map from '../components/Map';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "legacy-google-provider"
    }}>{`Legacy Google Provider`}</h1>
    <p><strong parentName="p"><u>{`WARNING`}</u>{`: This provider is unsafe to use and should be considered `}<u>{`DEPRECATED`}</u>{`.
It is strongly suggested to use the new `}<a parentName="strong" {...{
          "href": "/providers/google"
        }}>{`Google Provider`}</a>{`. If you're currently migrating from a previous version
and you still wish to use this provider you should pull in the `}<inlineCode parentName="strong">{`LegacyGoogleProvider`}</inlineCode>{` class
and rename your references accordingly.`}</strong></p>
    <p><strong parentName="p">{`note`}</strong>{`: Google services require an API key. `}<a parentName="p" {...{
        "href": "https://developers.google.com/maps/documentation/javascript/get-api-key"
      }}>{`Obtain here`}</a>{`.
For more options and configurations, see the `}<a parentName="p" {...{
        "href": "https://developers.google.com/maps/documentation/geocoding/start"
      }}>{`Google Maps developer docs`}</a>{`.`}</p>
    <Playground __position={0} __code={'<Map provider=\"Google\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Map,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Map provider="Google" mdxType="Map" />
    </Playground>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { LegacyGoogleProvider } from 'leaflet-geosearch';

const provider = new LegacyGoogleProvider({
  params: {
    key: '__YOUR_GOOGLE_KEY__',
  },
});

// add to leaflet
import { GeoSearchControl } from 'leaflet-geosearch';

map.addControl(
  new GeoSearchControl({
    provider,
    style: 'bar',
  }),
);
`}</code></pre>
    <h2 {...{
      "id": "optional-parameters"
    }}>{`Optional parameters`}</h2>
    <p>{`Google supports a number of `}<a parentName="p" {...{
        "href": "https://developers.google.com/maps/documentation/geocoding/intro#geocoding"
      }}>{`optional parameters`}</a>{`. As Google requires those parameters to be added to the url, they can be added to the `}<inlineCode parentName="p">{`params`}</inlineCode>{` key of the provider.`}</p>
    <p>{`All options defined next to the `}<inlineCode parentName="p">{`params`}</inlineCode>{` key, would have been added to the request body.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const provider = new LegacyGoogleProvider({
  params: {
    key: '__YOUR_GOOGLE_KEY__',
    language: 'nl', // render results in Dutch
    region: 'nl', // prioritize matches within The Netherlands
  },
});
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      